document.addEventListener('DOMContentLoaded', function () {
  initializeCarousels();
  observeProductGrid();
  editorialLazyLoad();
  initializeExpandableItems();
  initializeProductCardVideos();
  initWishlistPriceFormatter();
  initWishlistCtaLabelUpdater();
  initWishlistLoadingIndicator();
  initWishlistQuickAddWatcher();
  initWishlistRedirects();
  initWishlistLayoutWrapper();
  autoOpenFiltersFromTrends();
  watchMobileFacetsModalOpen();
  mirrorUrlFiltersIntoForm();
});

let currentMode = window.innerWidth < 750 ? 'mobile' : 'desktop';

window.addEventListener('resize', function () {
  const newMode = window.innerWidth < 750 ? 'mobile' : 'desktop';

  if (newMode !== currentMode) {
    currentMode = newMode;
    initializeExpandableItems();
  }
});

document.addEventListener('shopify:section:load', (event) => {
  initializeCarousels(event.target);
  initializeProductCardVideos(event.target);
  applyWishlistPriceFormatting(event.target);
  updateWishlistCtaLabels(event.target);
  initWishlistLoadingIndicator();
  initWishlistQuickAdd(event.target);
  initWishlistRedirects(event.target);
});

document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;

  // ==== SELECTORES: AJUSTA SI TU TEMA USA OTROS ====
  const SELECTORS = {
    galleryContainer: '.product-gallery-container, .product-image-container',
    flickityViewport: '.product-images .flickity-viewport',
    firstSlideImg: '.product-images img',
    // Todo lo que pueda ocupar la zona inferior con position:fixed
    bottomFixed: [
      '.product-add-to-cart-sticky',
      '.product-information--inner variant-selects', // panel de variantes fijo
      'variant-selects[style*="position:fixed"]',
      '.product-information--inner .product-form', // CTA fijo
      '.product-form[style*="position:fixed"]',
      '.product-information--inner [style*="position: fixed"]',
    ],
    header: '.shopify-section-header, header.header, .site-header',
  };

  function q(sel) {
    return document.querySelector(sel);
  }
  function qq(sels) {
    const nodes = [];
    sels.forEach((s) =>
      document.querySelectorAll(s).forEach((n) => nodes.push(n)),
    );
    // Filtra solo los que realmente están visibles en el flujo
    return nodes.filter((n) => {
      const r = n.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }
  function px(n) {
    return (Math.round(n) || 0) + 'px';
  }

  function measureOccupiedBottom() {
    const fixedEls = qq(SELECTORS.bottomFixed);
    if (fixedEls.length === 0) return 0;

    // Tomamos el elemento "más alto" (el que empieza antes desde arriba)
    // y calculamos el tramo ocupado desde su top hasta el bottom de la viewport (unión habitual).
    const minTop = Math.min(
      ...fixedEls.map((el) => el.getBoundingClientRect().top),
    );
    const occupied = Math.max(0, window.innerHeight - minTop);

    // Añade el safe area de iOS vía CSS env(); aquí no hace falta sumarlo.
    return occupied;
  }

  function headerHeight() {
    const h = q(SELECTORS.header);
    if (!h) return 0;
    const cs = getComputedStyle(h);
    if (cs.position === 'fixed' || cs.position === 'sticky') {
      return h.getBoundingClientRect().height || 0;
    }
    return 0;
  }

  function naturalSlideHeight(containerWidth) {
    // Calculamos el alto ideal de la imagen por su ratio
    const img = q(SELECTORS.firstSlideImg);
    if (!img || !img.naturalWidth || !img.naturalHeight) return 0;
    const ratio = img.naturalHeight / img.naturalWidth;
    return containerWidth * ratio; // alto natural a ese ancho
  }

  function applyHeights() {
    // Requiere que existan estas utilidades del snippet previo:
    // q(), px(), measureOccupiedBottom(), headerHeight(), naturalSlideHeight()
    // y SELECTORS.galleryContainer, SELECTORS.flickityViewport

    const gallery = q(SELECTORS.galleryContainer);
    const viewport = q(SELECTORS.flickityViewport) || gallery;
    if (!gallery || !viewport) return;

    // 1) Espacio disponible en viewport por encima de lo fijo (CTA/variants) y del header
    const occupied = measureOccupiedBottom(); // CTA + variants con position:fixed
    const headH = headerHeight(); // header si es fixed/sticky
    const available = Math.max(0, window.innerHeight - occupied - headH);

    // 2) Altura natural de la imagen a este ancho (para no estirar imágenes pequeñas)
    const cw = gallery.clientWidth || viewport.clientWidth || window.innerWidth;
    const natural = naturalSlideHeight(cw); // 0 si la imagen aún no cargó

    // 3) Altura final del carrusel = min(available, natural) / fallback a available
    const target = Math.max(0, Math.min(available, natural || available));
    const finalHeight = target > 0 ? target : available;

    // 4) Aplicar altura a contenedor y a la viewport de Flickity
    gallery.style.height = px(finalHeight);
    viewport.style.height = px(finalHeight);

    // 5) Proteger los dots con padding interno (en el contenedor donde viven los dots)
    //    Así los dots siempre están a 15px del borde del contenedor y “suben” a la par.
    const containerForDots =
      document.querySelector('.product-images') || gallery;
    if (containerForDots) {
      const rect = containerForDots.getBoundingClientRect();

      // Gap desde el bottom del contenedor hasta el bottom de la ventana
      const containerBottomGap = Math.max(0, window.innerHeight - rect.bottom);

      // Si los fijos pisan al contenedor, añadimos padding interno ( +12px de aire )
      const overlap = occupied - containerBottomGap; // puede ser <= 0
      const avoidBottom = overlap > 0 ? overlap + 12 : 0;

      document.documentElement.style.setProperty(
        '--avoid-bottom',
        px(avoidBottom),
      );
    }

    // (Opcional) dejar estas vars para depurar o reutilizar en CSS
    document.documentElement.style.setProperty('--header-h', px(headH));
  }

  // Ejecuta al cargar
  applyHeights();

  // Recalcula con cambios comunes
  ['resize', 'orientationchange', 'scroll'].forEach((ev) =>
    window.addEventListener(ev, applyHeights, { passive: true }),
  );

  // Recalcula cuando cambien los elementos fijos (CTA / variantes)
  const watch = qq(SELECTORS.bottomFixed);
  const ro =
    'ResizeObserver' in window ? new ResizeObserver(applyHeights) : null;
  watch.forEach((el) => {
    ro && ro.observe(el);
    new MutationObserver(applyHeights).observe(el, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  });

  // Recalcula cuando cargue la imagen (para tener naturalWidth/Height)
  const img = q(SELECTORS.firstSlideImg);
  if (img) {
    if (img.complete) applyHeights();
    else img.addEventListener('load', applyHeights, { once: true });
  }
});

const imageCarouselInstances = new Map();

function cleanupDetachedCarousels() {
  imageCarouselInstances.forEach((instance, container) => {
    if (!container.isConnected) {
      instance.destroy();
      imageCarouselInstances.delete(container);
    }
  });
}

function initializeCarousels(context = document) {
  cleanupDetachedCarousels();

  let carousels = [];
  if (
    context &&
    context.matches &&
    context.matches('div.container-carousel, .container-carousel')
  ) {
    carousels = [context];
  } else if (context && context.querySelectorAll) {
    carousels = context.querySelectorAll('div.container-carousel');
  } else {
    carousels = document.querySelectorAll('div.container-carousel');
  }

  carousels.forEach(function (carouselContainer) {
    if (!imageCarouselInstances.has(carouselContainer)) {
      const instance = new ImageCarousel(carouselContainer);
      imageCarouselInstances.set(carouselContainer, instance);
      carouselContainer.classList.add('custom-carousel-initial');
    }
  });
}

function observeProductGrid() {
  const productGridContainer = document.querySelector('#ProductGridContainer');
  if (!productGridContainer) return;

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        initializeCarousels();
        initializeProductCardVideos();
      }
    });
  });

  observer.observe(productGridContainer, {
    childList: true,
    subtree: true,
  });
}

function initializeProductCardVideos(context = document) {
  const videos = context.querySelectorAll('video[data-product-card-video]');
  if (!videos.length) {
    return;
  }

  videos.forEach((video) => {
    if (video.dataset.productCardVideoInit === 'true') {
      return;
    }
    video.dataset.productCardVideoInit = 'true';

    const ensureInlinePlayback = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.removeAttribute('controls');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    };

    const setupVisibilityObserver = () => {
      if (video._productCardVideoObserver) {
        return;
      }
      video._productCardVideoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              ensureInlinePlayback();
              video.play().catch(() => {});
              observer.unobserve(video);
            }
          });
        },
        { threshold: 0.35 },
      );
      video._productCardVideoObserver.observe(video);
    };

    const attemptAutoplay = () => {
      ensureInlinePlayback();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          setupVisibilityObserver();
        });
      }
    };

    if (video.readyState >= 2) {
      attemptAutoplay();
    } else {
      video.addEventListener('loadeddata', attemptAutoplay, { once: true });
      video.addEventListener('loadedmetadata', attemptAutoplay, { once: true });
    }

    // As a final fallback, ensure attributes are set when the user interacts.
    video.addEventListener('touchstart', ensureInlinePlayback, { once: true });
    video.addEventListener('click', ensureInlinePlayback, { once: true });

    // Attempt autoplay after the current call stack to catch browsers that delay readyState.
    requestAnimationFrame(attemptAutoplay);
  });
}

function editorialLazyLoad() {
  if (
    document.querySelector(
      'body.template-article #main-content .grid__item.animation',
    )
  ) {
    const animateOnScroll = (elements) => {
      gsap.fromTo(
        elements,
        { scale: 0.9, opacity: 0, filter: 'blur(8px)' },
        {
          scale: 1,
          opacity: 1,
          filter: 'blur(0px)',
          stagger: 0.15,
          ease: window.theme.settings.animation_easing,
        },
      );
    };

    const animationObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateOnScroll([entry.target]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    document
      .querySelectorAll(
        'body.template-article #main-content .grid__item.animation',
      )
      .forEach((item) => {
        animationObserver.observe(item);
      });

    const lazyObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const video = entry.target.querySelector('video');
            const img = entry.target.querySelector('img');

            if (video && video.dataset.src) {
              video.src = video.dataset.src;
              video.play();
            }

            if (img && img.dataset.src) {
              img.src = img.dataset.src;
              img.classList.add('loaded');
            }

            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    document
      .querySelectorAll(
        'body.template-article #main-content .grid__item.animation',
      )
      .forEach((item) => {
        lazyObserver.observe(item);
      });
  }
}

function initializeExpandableItems() {
  // Elimina cualquier comportamiento inicial
  document.querySelectorAll('.expandableItem').forEach((item) => {
    const header = item.querySelector('h4');
    const content = item.querySelector('.answerText');

    if (header && content) {
      header.classList.remove('active');
      content.classList.remove('active');
      content.style.display = 'none';
    }
  });

  // Paso 1: limpiar eventos reemplazando h4
  document.querySelectorAll('.expandableItem h4').forEach((header) => {
    const newHeader = header.cloneNode(true);
    header.parentNode.replaceChild(newHeader, header);
  });

  // Paso 2: volver a seleccionar los nuevos h4 y añadir eventos
  document.querySelectorAll('.expandableItem h4').forEach((header) => {
    header.addEventListener('click', function () {
      const currentItem = header.parentElement;
      const answer = header.nextElementSibling;
      const isOpen = header.classList.contains('active');

      if (isOpen) {
        // Cerrar si ya está abierto
        header.classList.remove('active');
        answer.classList.remove('active');
        slideUp(answer, 300);
      } else {
        // Cerrar los demás y abrir este
        closeAllExpandableItemsExcept(currentItem);
        header.classList.add('active');
        answer.classList.add('active');
        slideDown(answer, 300);
      }

      setTimeout(() => {
        if (typeof handleScroll === 'function') {
          handleScroll();
        }
      }, 300);
    });
  });
}

function closeAllExpandableItemsExcept(currentItem) {
  const allItems = document.querySelectorAll('.expandableItem');

  allItems.forEach((item) => {
    if (item !== currentItem) {
      const h4 = item.querySelector('h4');
      const answer = item.querySelector('.answerText');

      h4.classList.remove('active');
      answer.classList.remove('active');
      slideUp(answer, 300);
    }
  });
}

function slideUp(element, duration = 300) {
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight; // force reflow
  element.style.transition = `height ${duration}ms ease`;
  element.style.overflow = 'hidden';
  element.style.height = '0';

  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}

function slideDown(element, duration = 300) {
  element.style.removeProperty('display'); // reset display first
  let display = window.getComputedStyle(element).display;

  if (display === 'none') {
    display = 'block';
  }

  element.style.display = display;
  const height = element.offsetHeight;
  element.style.height = '0';
  element.style.overflow = 'hidden';
  element.offsetHeight; // force reflow
  element.style.transition = `height ${duration}ms ease`;
  element.style.height = height + 'px';

  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}

class ImageCarousel {
  constructor(carouselContainer) {
    this.carouselContainer = carouselContainer;
    this.images = this.carouselContainer.querySelectorAll(
      'img:not(noscript img)',
    );
    this.productImageLink = this.carouselContainer.closest(
      '.product-featured-image-link',
    );
    this.handleResize = this.handleResize.bind(this);
    this.resizeObserver = null;
    this.flickity = null;

    if (this.images.length > 1) {
      this.syncCarouselHeight();
      this.init();
      this.setupResponsiveSync();
    }
  }

  syncCarouselHeight() {
    if (!this.productImageLink) {
      return;
    }
    const targetHeight = this.productImageLink.offsetHeight;
    if (!targetHeight) {
      return;
    }
    this.carouselContainer.style.height = `${targetHeight}px`;
    const viewport = this.carouselContainer.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = `${targetHeight}px`;
    }
    if (this.flickity && this.flickity.resize) {
      this.flickity.resize();
    }
  }

  setupResponsiveSync() {
    window.addEventListener('resize', this.handleResize, { passive: true });

    if ('ResizeObserver' in window && this.productImageLink) {
      this.resizeObserver = new ResizeObserver(() => this.syncCarouselHeight());
      this.resizeObserver.observe(this.productImageLink);
    }
  }

  handleResize() {
    this.syncCarouselHeight();
  }

  destroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.flickity && this.flickity.destroy) {
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  init() {
    this.flickity = new Flickity(this.carouselContainer, {
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'center',
      contain: true,
      groupCells: true,
      setGallerySize: false,
    });

    const prevButton = this.carouselContainer.querySelector(
      '.flickity-prev-next-button.previous',
    );
    const nextButton = this.carouselContainer.querySelector(
      '.flickity-prev-next-button.next',
    );

    if (prevButton) {
      prevButton.innerHTML = `<svg aria-hidden="true" width="11px" height="15px" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
    }

    if (nextButton) {
      nextButton.innerHTML = `<svg aria-hidden="true" focusable="false" width="11px" height="15px" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
    }

    [prevButton, nextButton].forEach((button) => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
        });
      }
    });

    this.syncCarouselHeight();
  }
}

function stripDecimalsFromText(text) {
  if (!text) {
    return text;
  }
  const normalized = text.replace(/\u00a0/g, ' ');
  const hasDecimals = /([.,]\d+)(?=[^\d]*$)/.test(normalized);
  if (!hasDecimals) {
    return text;
  }
  const updated = normalized.replace(/([.,]\d+)(?=[^\d]*$)/, '');
  return updated;
}

function formatWishlistPriceElement(element) {
  if (!element) {
    return;
  }
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    null,
    false,
  );
  const updates = [];
  while (walker.nextNode()) {
    const current = walker.currentNode;
    const stripped = stripDecimalsFromText(current.textContent);
    if (stripped !== current.textContent) {
      updates.push({ node: current, value: stripped });
    }
  }
  updates.forEach(({ node, value }) => {
    node.textContent = value;
  });
}

function applyWishlistPriceFormatting(root = document) {
  if (!root || !root.querySelectorAll) {
    return;
  }
  root
    .querySelectorAll('.st-product-card_price')
    .forEach(formatWishlistPriceElement);
  if (root.classList && root.classList.contains('st-product-card_price')) {
    formatWishlistPriceElement(root);
  }
}

function initWishlistPriceFormatter() {
  if (window.__wishlistPriceFormatterInitialized) {
    applyWishlistPriceFormatting();
    return;
  }
  window.__wishlistPriceFormatterInitialized = true;

  applyWishlistPriceFormatting();

  let pending = null;
  const observer = new MutationObserver(() => {
    if (pending) {
      window.cancelAnimationFrame(pending);
    }
    pending = window.requestAnimationFrame(() => {
      pending = null;
      applyWishlistPriceFormatting();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  window.addEventListener('load', () => applyWishlistPriceFormatting());
}

function updateWishlistCtaLabels(root = document) {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }
  if (!root) {
    return;
  }

  const label =
    (document.body.dataset && document.body.dataset.wishlistAtcLabel) ||
    'Add to cart';
  if (!label) {
    return;
  }

  const selector = '.st-atc-button';
  const buttons = [];

  if (root.matches && root.matches(selector)) {
    buttons.push(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll(selector).forEach((button) => buttons.push(button));
  }

  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    if (!button) {
      return;
    }
    let labelTarget =
      button.querySelector('.st-atc-button__text') ||
      button.querySelector('span');
    if (!labelTarget) {
      labelTarget = button;
    }
    const current = (labelTarget.textContent || '').trim();
    if (current === label) {
      return;
    }
    labelTarget.textContent = label;
  });
}

function initWishlistCtaLabelUpdater() {
  if (window.__wishlistCtaLabelInitialized) {
    updateWishlistCtaLabels();
    return;
  }
  window.__wishlistCtaLabelInitialized = true;
  updateWishlistCtaLabels();

  let pending = null;
  const observer = new MutationObserver(() => {
    if (pending) {
      window.cancelAnimationFrame(pending);
    }
    pending = window.requestAnimationFrame(() => {
      pending = null;
      updateWishlistCtaLabels();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('load', () => updateWishlistCtaLabels());
}

function initWishlistLoadingIndicator() {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }
  ensureWishlistLoadingElement();
  toggleWishlistLoadingState();

  if (window.__wishlistLoadingObserverInitialized) {
    return;
  }
  window.__wishlistLoadingObserverInitialized = true;
  const target = document.querySelector('#main-content') || document.body;
  const observer = new MutationObserver(() => {
    toggleWishlistLoadingState();
  });
  observer.observe(target, {
    childList: true,
    subtree: true,
  });
  window.addEventListener('load', toggleWishlistLoadingState);
}

function ensureWishlistLoadingElement() {
  if (document.querySelector('.wishlist-loading-state')) {
    return;
  }
  const rawMessage =
    (document.body.dataset && document.body.dataset.wishlistLoadingText) || '';
  const normalized = rawMessage.toLowerCase();
  const message =
    !rawMessage || normalized.includes('translation missing')
      ? 'Loading wishlist...'
      : rawMessage;
  const loader = document.createElement('div');
  loader.className = 'wishlist-loading-state';
  loader.setAttribute('role', 'status');
  loader.setAttribute('aria-live', 'polite');
  loader.innerHTML = `<span>${message}</span>`;
  const container = document.querySelector('#main-content') || document.body;
  container.insertBefore(loader, container.firstChild || null);
}

function toggleWishlistLoadingState() {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }
  const hasItems = Boolean(
    document.querySelector('.st-product-card, .st-product-card--grid'),
  );
  document.body.classList.toggle('wishlist-has-items', hasItems);
  const loader = document.querySelector('.wishlist-loading-state');
  if (loader) {
    if (hasItems) {
      loader.remove();
    } else {
      loader.hidden = false;
      loader.setAttribute('aria-hidden', 'false');
    }
  }
}

const wishlistVariantCache = {};
let wishlistQuickAddObserver = null;

function initWishlistQuickAdd(root = document) {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }
  if (!root) {
    return;
  }

  const selector = '.st-atc-button';
  const buttons = [];

  if (root.matches && root.matches(selector)) {
    buttons.push(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll(selector).forEach((button) => buttons.push(button));
  }

  buttons.forEach((button) => {
    if (!button || button.dataset.wishlistQuickAddBound === 'true') {
      return;
    }
    button.dataset.wishlistQuickAddBound = 'true';
    button.addEventListener(
      'click',
      (event) => handleWishlistQuickAdd(event, button),
      { capture: true },
    );
  });
}

function initWishlistQuickAddWatcher() {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }
  initWishlistQuickAdd();
  if (wishlistQuickAddObserver) {
    return;
  }
  wishlistQuickAddObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        initWishlistQuickAdd(node);
      });
    });
  });
  wishlistQuickAddObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
  window.addEventListener('load', () => initWishlistQuickAdd());
}

function handleWishlistQuickAdd(event, button) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  const context = getWishlistProductContext(button);
  if (!context.variantId && !context.handle) {
    if (context.productUrl) {
      window.location.assign(context.productUrl);
    }
    return;
  }

  if (button.dataset.wishlistAtcLoading === 'true') {
    return;
  }

  const normalizedContext = { ...context };
  let hasRetried = false;

  setWishlistButtonLoading(button, true);

  const attemptAdd = (forceProductFetch = false) =>
    resolveWishlistVariantId(normalizedContext, { forceProductFetch }).then(
      (variantId) => addVariantToCartRequest(variantId),
    );

  attemptAdd()
    .catch((error) => {
      if (
        !hasRetried &&
        shouldRetryWishlistQuickAdd(error, normalizedContext)
      ) {
        hasRetried = true;
        normalizedContext.variantId = null;
        return attemptAdd(true);
      }
      throw error;
    })
    .then((item) => {
      indicateWishlistButtonSuccess(button);
      removeWishlistItemFromPage(button);
      dispatchWishlistCartEvent(item);
      refreshWishlistCartUi();
    })
    .catch((error) => {
      console.error('[Wishlist Quick Add] Unable to add product to cart', {
        error,
        context: normalizedContext,
      });
      const fallbackMessage =
        (error && (error.description || error.errors || error.message)) ||
        (window.theme &&
          window.theme.variantStrings &&
          (window.theme.variantStrings.unavailable ||
            window.theme.variantStrings.soldOut)) ||
        'Unable to add this product right now.';
      window.alert(fallbackMessage);
    })
    .finally(() => {
      setWishlistButtonLoading(button, false);
    });
}

function setWishlistButtonLoading(button, isLoading) {
  if (!button) {
    return;
  }
  button.dataset.wishlistAtcLoading = isLoading ? 'true' : 'false';
  button.classList.toggle('is-loading', Boolean(isLoading));
  if (isLoading) {
    button.setAttribute('aria-busy', 'true');
    if (button.tagName === 'BUTTON') {
      button.setAttribute('disabled', 'disabled');
    }
  } else {
    button.removeAttribute('aria-busy');
    if (button.tagName === 'BUTTON') {
      button.removeAttribute('disabled');
    }
  }
}

function indicateWishlistButtonSuccess(button) {
  if (!button) {
    return;
  }
  button.classList.add('is-added');
  window.setTimeout(() => {
    button.classList.remove('is-added');
  }, 1500);
}

function removeWishlistItemFromPage(button) {
  if (!button) {
    return;
  }

  const card =
    button.closest('.st-product-card') ||
    button.closest('.st-product-card--grid') ||
    button.closest('[data-product-handle]') ||
    button.closest('[data-handle]');

  if (!card) {
    return;
  }

  const deleteButton =
    card.querySelector('.st-delete-button') ||
    card.querySelector('.st-product-card_actions .st-wishlist-button') ||
    card.querySelector('[data-action="remove"]');

  if (deleteButton && typeof deleteButton.click === 'function') {
    deleteButton.click();
    return;
  }

  card.remove();
  toggleWishlistLoadingState();
}

function dispatchWishlistCartEvent(item) {
  const detail = { product: item };
  if (typeof dispatchCustomEvent === 'function') {
    dispatchCustomEvent('cart:item-added', detail);
    return;
  }
  document.dispatchEvent(
    new CustomEvent('cart:item-added', {
      detail,
    }),
  );
}

function resolveWishlistVariantId(context = {}, options = {}) {
  const { forceProductFetch = false } = options;
  if (!forceProductFetch && context.variantId) {
    return Promise.resolve(context.variantId);
  }

  const handle = context.handle;
  if (!handle) {
    if (context.variantId) {
      return Promise.resolve(context.variantId);
    }
    return Promise.reject(new Error('Missing product handle'));
  }
  if (!forceProductFetch && wishlistVariantCache[handle]) {
    return Promise.resolve(wishlistVariantCache[handle]);
  }
  const endpoint = `/products/${handle}.js`;
  return fetch(endpoint, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Unable to load product data');
      }
      return response.json();
    })
    .then((product) => {
      if (
        !product ||
        !Array.isArray(product.variants) ||
        !product.variants.length
      ) {
        throw new Error('Product has no variants');
      }
      const sourceVariantId = context.variantId
        ? Number(context.variantId)
        : null;
      const matchingVariant = sourceVariantId
        ? product.variants.find((item) => Number(item.id) === sourceVariantId)
        : null;
      const variant =
        matchingVariant ||
        product.variants.find((item) => item.available) ||
        product.variants[0];
      if (!variant || !variant.id) {
        throw new Error('Variant is unavailable');
      }
      wishlistVariantCache[handle] = variant.id;
      return variant.id;
    });
}

function shouldRetryWishlistQuickAdd(error, context) {
  if (!context || !context.handle || !context.variantId) {
    return false;
  }
  const message =
    (error && (error.description || error.errors || error.message)) ||
    'cart error';
  return /cart error|unprocessable|variant|id/gi.test(message);
}

function resolveCartAddEndpoint() {
  return '/cart/add.js';
}

function addVariantToCartRequest(variantId, quantity = 1) {
  if (!variantId) {
    return Promise.reject(new Error('Missing variant id'));
  }
  const endpoint = resolveCartAddEndpoint();
  const formData = new URLSearchParams();
  formData.append('id', variantId);
  formData.append('quantity', Number(quantity) || 1);
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: formData.toString(),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((error) => {
        throw error;
      });
    }
    return response.json();
  });
}

function refreshWishlistCartUi() {
  updateWishlistCartCountFromServer();
  dispatchWishlistRefreshEvent();
}

function updateWishlistCartCountFromServer() {
  fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      if (!cart || typeof cart.item_count === 'undefined') {
        return;
      }
      const count = Number(cart.item_count) || 0;
      document.querySelectorAll('.thb-item-count').forEach((badge) => {
        if (!badge) {
          return;
        }
        badge.textContent = count > 0 ? count : '';
      });
    })
    .catch(() => {});
}

function dispatchWishlistRefreshEvent() {
  const eventName = 'cart:refresh';
  if (typeof dispatchCustomEvent === 'function') {
    dispatchCustomEvent(eventName);
  } else {
    document.dispatchEvent(new CustomEvent(eventName));
  }
}

function getWishlistProductContext(button) {
  const context = {
    variantId: null,
    handle: null,
    productUrl: null,
  };
  if (!button) {
    return context;
  }
  const dataset = button.dataset || {};
  context.variantId =
    dataset.variantId ||
    dataset.variant ||
    dataset.id ||
    dataset.productVariant ||
    null;
  context.handle = dataset.productHandle || dataset.handle || null;
  context.productUrl =
    (button.getAttribute ? button.getAttribute('href') : null) ||
    dataset.productUrl ||
    dataset.url ||
    null;

  const card =
    button.closest('.st-product-card') ||
    button.closest('[data-product-handle]') ||
    button.closest('[data-handle]');

  if (card) {
    const cardData = card.dataset || {};
    context.variantId =
      context.variantId || cardData.variantId || cardData.id || null;
    context.handle =
      context.handle || cardData.productHandle || cardData.handle || null;
    if (!context.productUrl) {
      const link =
        card.querySelector('.st-image a[href*="/products/"]') ||
        card.querySelector('.st-product-card_title a') ||
        card.querySelector('a[href*="/products/"]');
      if (link) {
        context.productUrl = link.getAttribute('href');
        context.handle =
          context.handle || extractHandleFromUrl(context.productUrl);
      }
    }
  }

  if (!context.handle && context.productUrl) {
    context.handle = extractHandleFromUrl(context.productUrl);
  }

  return context;
}

function extractHandleFromUrl(url) {
  if (!url) {
    return null;
  }
  try {
    const parsed = new URL(url, window.location.origin);
    const segments = parsed.pathname.split('/').filter(Boolean);
    const productsIndex = segments.indexOf('products');
    if (productsIndex !== -1 && segments[productsIndex + 1]) {
      return segments[productsIndex + 1];
    }
    return segments.pop() || null;
  } catch (error) {
    return url
      .replace(/^\/+/, '')
      .replace(/\/+$/, '')
      .replace(/^products\//, '')
      .split('?')[0]
      .split('#')[0];
  }
}

function initWishlistRedirects(root = document) {
  if (!root) {
    return;
  }
  const selector = 'button.st-wishlist-details-button[data-wishlist-url]';
  const buttons = [];

  if (root.matches && root.matches(selector)) {
    buttons.push(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll(selector).forEach((button) => buttons.push(button));
  }

  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    if (!button || button.dataset.wishlistRedirectBound === 'true') {
      return;
    }
    button.dataset.wishlistRedirectBound = 'true';
    button.type = 'button';
    const handleRedirect = (event) => {
      const url = button.dataset.wishlistUrl || '/pages/wishlist';
      if (!url) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.assign(url);
    };
    button.addEventListener('click', handleRedirect, { capture: true });
  });
}

function initWishlistLayoutWrapper() {
  if (
    !document.body ||
    !document.body.classList.contains('template-page-wishlist-page')
  ) {
    return;
  }

  function wrapWishlistElements() {
    const productCards = document.querySelectorAll('.st-product-card--grid');

    productCards.forEach((card) => {
      if (card.dataset.wishlistWrapped === 'true') return;

      const titleGroup = card.querySelector('.st-product-card_group--title');
      const quantityGroup = card.querySelector(
        '.st-product-card_group--quantity',
      );
      const button = card.querySelector('.st-atc-button');

      if (!titleGroup || !quantityGroup || !button) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'wishlist-custom-wrapper';

      const textWrapper = document.createElement('div');
      textWrapper.className = 'wishlist-text-wrapper';

      // Insertar wrapper antes del titleGroup
      titleGroup.parentNode.insertBefore(wrapper, titleGroup);

      // Mover título y precio al textWrapper
      textWrapper.appendChild(titleGroup);
      textWrapper.appendChild(quantityGroup);

      // Añadir textWrapper y botón al wrapper principal
      wrapper.appendChild(textWrapper);
      wrapper.appendChild(button);

      card.dataset.wishlistWrapped = 'true';
    });
  }

  wrapWishlistElements();

  const observer = new MutationObserver(() => {
    wrapWishlistElements();
  });

  const target = document.querySelector('#main-content') || document.body;
  observer.observe(target, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('load', wrapWishlistElements);
}

// ✅ FACETS: custom.js NO TOCA estado de filtros en MOBILE (evita duplicidad con facets.js)
// Desktop se queda igual que antes para open desde trends.

function autoOpenFiltersFromTrends() {
  if (!window.location.search.includes('open_filters=true')) return;

  let attempts = 0;

  function tryOpenFilters() {
    attempts++;

    const isDesktop = window.matchMedia('(min-width: 1068px)').matches;

    // DESKTOP → abrir sidebar
    if (isDesktop) {
      const facetsForm = document.querySelector('facet-filters-form');
      if (facetsForm) {
        console.log('Auto-opening desktop filters from trends view');
        facetsForm.classList.add('filters-expanded');
        return true;
      }
    }

    // MOBILE → abrir modal (simula click en el botón Filtrar)
    const mobileToggle =
      document.querySelector('#Facets-Toggle-Fixed') ||
      document.querySelector('#Facets-Toggle-Bar') ||
      document.querySelector('facet-toggle.facets-toggle--fixed') ||
      document.querySelector('facet-toggle.facets-toggle--link');

    if (mobileToggle) {
      console.log('Auto-opening mobile filters from trends view');

      // ✅ IMPORTANTE: aquí NO hacemos sync, NO mirror, NO retries.
      // Dejamos que facets.js gestione todo el estado.
      mobileToggle.click();
      return true;
    }

    return false;
  }

  function loop() {
    if (tryOpenFilters()) return;
    if (attempts > 30) return;
    setTimeout(loop, 200);
  }

  window.addEventListener('load', () => {
    setTimeout(loop, 200);
  });
}

// Ejecutar
autoOpenFiltersFromTrends();